import _ from 'lodash';
import { getDeviceProps } from './utils';
import { variables } from '../themes/_variablesFox';

const {
  layout: { breakpoint },
} = variables;
const desktopLargeMinBreakpoint = parseInt(breakpoint.desktopLargeMin.replace('px', ''), 10);
const desktopMinBreakpoint = parseInt(breakpoint.desktopMin.replace('px', ''), 10);
const tabletMinBreakpoint = parseInt(breakpoint.tabletMin.replace('px', ''), 10);
export const DEBOUNCE_TIME = 1000;

const siteBreakpoints = _.get(window.ExternalConfig, 'breakpoints.site');
export const TABLET_LANDSCAPE_BREAKPOINT = 1024;
export const DESKTOP_MIN_BREAKPOINT = 1099;
export const DESKTOP_BREAKPOINT = 1440;
export const XL_BREAKPOINT = 2560;
export const SITE_PLATFORM_WEB = _.get(siteBreakpoints, 'web');
export const SITE_PLATFORM_TABLET = _.get(siteBreakpoints, 'tablet');
export const SITE_PLATFORM_MOBILE = _.get(siteBreakpoints, 'mobile');
export const SITE_PLATFORM_WEB_LARGE = _.get(siteBreakpoints, 'webLarge');
const SITE_PLATFORM_BREAKPOINTS = {
  [SITE_PLATFORM_WEB_LARGE]: desktopLargeMinBreakpoint,
  [SITE_PLATFORM_WEB]: desktopMinBreakpoint,
  [SITE_PLATFORM_TABLET]: tabletMinBreakpoint,
  [SITE_PLATFORM_MOBILE]: 0,
};

const playerBreakpoints = _.get(window.ExternalConfig, 'breakpoints.player');
export const PLAYER_PLATFORM_WEB = _.get(playerBreakpoints, 'web');
export const PLAYER_PLATFORM_TABLET = _.get(playerBreakpoints, 'tablet');
export const PLAYER_PLATFORM_MOBILE = _.get(playerBreakpoints, 'mobile');
const PLAYER_BREAKPOINTS = {
  [PLAYER_PLATFORM_WEB]: desktopMinBreakpoint,
  [PLAYER_PLATFORM_TABLET]: tabletMinBreakpoint,
  [PLAYER_PLATFORM_MOBILE]: 0,
};

export const isMobileBreakpoint = breakpoint => breakpoint === SITE_PLATFORM_MOBILE;
export const isTabletBreakpoint = breakpoint => breakpoint === SITE_PLATFORM_TABLET;
export const isDesktopBreakpoint = breakpoint => breakpoint === SITE_PLATFORM_WEB;
export const isLargeDesktopBreakpoint = breakpoint => breakpoint === SITE_PLATFORM_WEB_LARGE;

/**
 * Return the site breakpoint for the specific platform size
 * @param {Number} windowWidth     - Width of the current browser window
 * @return {String}                - Breakpoint ID
 */
export const getSitePlatform = (windowWidth = window.innerWidth) => {
  const webLargeBreakpoint = windowWidth >= SITE_PLATFORM_BREAKPOINTS[SITE_PLATFORM_WEB_LARGE];
  if (webLargeBreakpoint) return SITE_PLATFORM_WEB_LARGE;
  if (windowWidth >= SITE_PLATFORM_BREAKPOINTS[SITE_PLATFORM_WEB]) return SITE_PLATFORM_WEB;
  if (windowWidth >= SITE_PLATFORM_BREAKPOINTS[SITE_PLATFORM_TABLET]) return SITE_PLATFORM_TABLET;
  return SITE_PLATFORM_MOBILE;
};

/**
 * Return the player breakpoint for the specific platform size
 * @param {Number} windowWidth     - Width of the current browser window
 * @return {String}                - Breakpoint ID
 */
export const getPlayerPlatform = (windowWidth = window.innerWidth) => {
  if (windowWidth > PLAYER_BREAKPOINTS[PLAYER_PLATFORM_WEB]) {
    return PLAYER_PLATFORM_WEB;
  }
  if (windowWidth > PLAYER_BREAKPOINTS[PLAYER_PLATFORM_TABLET]) {
    return PLAYER_PLATFORM_TABLET;
  }
  return PLAYER_PLATFORM_MOBILE;
};

export const getUserDevice = () => getDeviceProps().deviceType.toLowerCase();

export const isAMobileDevice = () => getUserDevice() === 'mobile';
export const isATabletDevice = () => getUserDevice() === 'tablet';

export const largeTabletView = breakpointView =>
  breakpointView === SITE_PLATFORM_WEB && isATabletDevice();

export const defaultPosterResponsiveness = [
  {
    breakpoint: 767,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3,
    },
  },
  {
    breakpoint: 1023,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3,
    },
  },
  {
    breakpoint: 1439,
    settings: {
      slidesToShow: 4,
      slidesToScroll: 4,
    },
  },
  {
    breakpoint: 2559,
    settings: {
      slidesToShow: 5,
      slidesToScroll: 5,
    },
  },
  {
    breakpoint: 2560,
    settings: {
      slidesToShow: 6,
      slidesToScroll: 6,
    },
  },
];
